export default __webpack_public_path__ + "static/media/ds-ordenacao-filtros-desafios.f102c0be.png";